<template>
    <!-- 登录弹窗 -->
    <div class="login-wrap popup_wrap" v-if="visible" @click="closePopup">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }">
            <div class="login-box popup_wrap_box" v-show="visible" style="top:40%">

                <img class="swiper-lazy" :src="bgList[language]" alt="详情">
                <div style="width: 7.5rem; height: 9.1rem; margin-top: 2.8rem;">
                    <div class="rid-container">
                        <input type="text" v-model="localRid" @click.stop="onFocus" />
                    </div>
                    <div class="login_btn" @click.stop="onLogin"></div>
                </div>
                <div class="close-bg" v-show="visible" @click="closePopup"></div>
            </div>
        </transition>
    </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { bindUser } from "../../api.js"; // 替换为你的实际接口文件
import hkBg from "@/assets/images/active/snail/fifth/hk/login.png";
import { APP_ID } from "@/config/constant";
const SNAIL_ID = {
    'zh-tw': 'snail_tw', // 替换为你的实际 game_id
};

export default {
    name: "LoginPopup",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        language: {
            type: String,
            default: "zh-tw",
        }
    },
    data() {
        return {
            config: null,
            localRid: "",
            hkBg: hkBg,
            bgList: {
                "zh-tw": hkBg,
                "en": hkBg,
                "jp": hkBg,
            },
            msgList: {
                "zh-tw": {
                    success: "連結成功",
                    error: '連結失敗',
                    id: "請輸入ID"
                },
                "en": {
                    success: "連結成功",
                    error: '連結失敗',
                    id: "請輸入ID"
                },
                "jp": {
                    success: "連結成功",
                    error: '連結失敗',
                    id: "請輸入ID"
                },

            },
            game_id: 126,
            APP_ID: APP_ID,
            msg: {}
        };
    },
    created() {
        this.game_id = APP_ID[SNAIL_ID[this.language]];
        this.msg = this.msgList[this.language];
    },
    methods: {
        onFocus() {

        },
        init() {
            this.$emit('init')
        },
        showToast(msg) {
            Toast(msg);
        },
        closePopup() {
            this.localRid = "";
            this.$emit("updateVisible", false);
        },
        async onLogin() {
            console.log(this.game_id);
            if (!this.localRid) {
                return this.showToast(this.msg.id);
            }
            Indicator.open();
            try {
                const res = await bindUser({
                    role_id: this.localRid,
                    game_id: this.game_id,
                });
                if (res.code !== 200) {
                    return this.showToast(res.message);
                }

                this.showToast(this.msg.success);
                localStorage.setItem("access_token", res.data.access_token);
                this.$emit('init', res.data.access_token)

                this.$emit("login-success", {
                    token: res.data.access_token,
                    rid: this.localRid,
                });

                this.closePopup();
            } catch (err) {
                this.showToast(this.msg.error);
            } finally {
                Indicator.close();
            }
        },
    },
};
</script>


<style lang="less">
@import "./index.less";
</style>


// WEBPACK FOOTER //
// src/pages/snail/5thReport/components/Login/index.vue